// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__2cwZS","ThumbZoom":"ChapterPlayer_ThumbZoom__s0pA1"};